(() => {
  if (window.SilveringMarketInventoryLoaded) return;
  window.SilveringMarketInventoryLoaded = true;

  const STOREFRONT_TOKEN = '6fb5bc45644aa429de8606bc9cbc0ad7';
  const API_VERSION = '2026-07';
  const LOW_STOCK_LIMIT = 100;
  const PRODUCT_BATCH_SIZE = 30;

  const productCache = new Map();
  let loadTimer;

  const numericId = (gid) => String(gid || '').split('/').pop();

  const countryCode = () => {
    const source = document.querySelector('[data-market-country]');
    return (
      source?.dataset.marketCountry ||
      window.Shopify?.country ||
      'CA'
    ).toUpperCase();
  };

  const productElements = () => [
    ...document.querySelectorAll(
      '[data-market-inventory-card][data-product-id], [data-market-inventory-pdp][data-product-id]'
    ),
  ];

  const productIds = () => [
    ...new Set(
      productElements()
        .map((element) => element.dataset.productId)
        .filter(Boolean)
    ),
  ];

  async function requestProducts(ids) {
    const shop = window.Shopify?.shop;
    if (!shop || !ids.length) return [];

    const query = `
      query MarketInventory(
        $country: CountryCode!,
        $ids: [ID!]!
      ) @inContext(country: $country) {
        nodes(ids: $ids) {
          ... on Product {
            id
            title
            availableForSale
            variants(first: 20) {
              nodes {
                id
                title
                availableForSale
                currentlyNotInStock
                quantityAvailable
              }
            }
          }
        }
      }
    `;

    const response = await fetch(
      `https://${shop}/api/${API_VERSION}/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        body: JSON.stringify({
          query,
          variables: {
            country: countryCode(),
            ids: ids.map((id) => `gid://shopify/Product/${id}`),
          },
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`Inventory request failed (${response.status})`);
    }

    const payload = await response.json();

    if (payload.errors?.length) {
      throw new Error(
        payload.errors.map((error) => error.message).join('; ')
      );
    }

    return (payload.data?.nodes || []).filter(Boolean);
  }

  const availableVariants = (product) =>
    product.variants.nodes.filter(
      (variant) => variant.availableForSale
    );

  const isLowStock = (variant) =>
    variant.availableForSale &&
    !variant.currentlyNotInStock &&
    Number.isInteger(variant.quantityAvailable) &&
    variant.quantityAvailable > 0 &&
    variant.quantityAvailable < LOW_STOCK_LIMIT;

  function updateCard(card, product) {
    const badges = card.querySelectorAll(
      '[data-market-card-badge]'
    );

    if (!badges.length) return;

    const sellable = availableVariants(product);

    const label =
      sellable.length === 0
        ? 'Sold Out'
        : sellable.some(isLowStock)
          ? 'Low Stock'
          : '';

    badges.forEach((badge) => {
      badge.textContent = label;
      badge.classList.toggle('hidden', !label);
      badge.setAttribute(
        'aria-hidden',
        label ? 'false' : 'true'
      );
    });
  }

  function selectedVariantId(root) {
    return (
     root.querySelector('.product-variant-id')?.value ||
      root.dataset.selectedVariantId ||
      ''
    );
  }

  function findVariant(product, variantId) {
    return product.variants.nodes.find(
      (variant) =>
        numericId(variant.id) === String(variantId)
    );
  }

  function bisTag(product, variant) {
    const variantName =
      variant.title && variant.title !== 'Default Title'
        ? ` | ${variant.title}`
        : '';

    return `REQUESTED BACK IN STOCK | ${product.title}${variantName}`;
  }

  function updatePdp(root, product, requestedVariantId) {
    const variant = findVariant(
      product,
      requestedVariantId || selectedVariantId(root)
    );

    if (!variant) return;

    root.dataset.selectedVariantId = numericId(variant.id);

    const message = root.querySelector(
      '[data-market-pdp-message]'
    );

    if (message) {
      const showCount = isLowStock(variant);

      message.textContent = showCount
        ? `Low stock — ${variant.quantityAvailable} available`
        : '';

      message.hidden = !showCount;
    }

  const isUnavailable =
  !variant.availableForSale ||
  window.location.href.includes('notify_test=1');

const quantityForm = root.querySelector('.product-form__quantity');
if (quantityForm) quantityForm.hidden = isUnavailable;

const productForm = root.querySelector('product-form');
if (productForm) productForm.hidden = isUnavailable;

const notify = root.querySelector('[data-market-notify]');

if (notify) {
  notify.hidden = !isUnavailable;

      const tagInput = notify.querySelector(
        '[data-market-notify-tag]'
      );

      if (tagInput) {
        tagInput.value = bisTag(product, variant);
      }
    }
  }

  function honourFirstAvailableVariant(root, product) {
    const url = new URL(window.location.href);

    if (url.searchParams.has('variant')) return false;

    const current = findVariant(
      product,
      selectedVariantId(root)
    );

    if (current?.availableForSale) return false;

    const firstAvailable = availableVariants(product)[0];

    if (!firstAvailable) return false;

    url.searchParams.set(
      'variant',
      numericId(firstAvailable.id)
    );

    window.location.replace(url.toString());
    return true;
  }

  function render() {
    document
      .querySelectorAll(
        '[data-market-inventory-card][data-product-id]'
      )
      .forEach((card) => {
        const product = productCache.get(
          card.dataset.productId
        );

        if (product) updateCard(card, product);
      });

    document
      .querySelectorAll(
        '[data-market-inventory-pdp][data-product-id]'
      )
      .forEach((root) => {
        const product = productCache.get(
          root.dataset.productId
        );

        if (!product) return;

        if (honourFirstAvailableVariant(root, product)) {
          return;
        }

        updatePdp(root, product);
      });
  }

  async function loadMissingProducts() {
    const missing = productIds().filter(
      (id) => !productCache.has(id)
    );

    if (!missing.length) {
      render();
      return;
    }

    try {
      for (
        let index = 0;
        index < missing.length;
        index += PRODUCT_BATCH_SIZE
      ) {
        const products = await requestProducts(
          missing.slice(
            index,
            index + PRODUCT_BATCH_SIZE
          )
        );

        products.forEach((product) => {
          productCache.set(
            numericId(product.id),
            product
          );
        });
      }

      render();
    } catch (error) {
      console.error('[Silvering inventory]', error);
    }
  }

  function scheduleLoad() {
    window.clearTimeout(loadTimer);

    loadTimer = window.setTimeout(
      loadMissingProducts,
      60
    );
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(
      '[data-market-notify-toggle]'
    );

    if (!toggle) return;

    const notify = toggle.closest(
      '[data-market-notify]'
    );

    const panel = notify?.querySelector(
      '[data-market-notify-panel]'
    );

    if (!panel) return;

    const willOpen = panel.hidden;

    panel.hidden = !willOpen;
    toggle.setAttribute(
      'aria-expanded',
      String(willOpen)
    );

    if (willOpen) {
      panel
        .querySelector('input[type="email"]')
        ?.focus();
    }
  });

  document.addEventListener('change', (event) => {
    const picker = event.target.closest(
      'variant-radios, variant-selects'
    );

    if (!picker) return;

    window.setTimeout(() => {
      const root = picker.closest(
        '[data-market-inventory-pdp]'
      );

      const product =
        root &&
        productCache.get(root.dataset.productId);

      if (root && product) {
        updatePdp(
          root,
          product,
          selectedVariantId(root)
        );
      }
    }, 350);
  });

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(
      PUB_SUB_EVENTS.variantChange,
      (event) => {
        const data = event?.data || {};
        const sectionId = data.sectionId;

        const root = sectionId
          ? document.querySelector(
              `[data-market-inventory-pdp][data-section="${CSS.escape(
                String(sectionId)
              )}"]`
            )
          : document.querySelector(
              '[data-market-inventory-pdp]'
            );

        if (!root) return;

        const product = productCache.get(
          root.dataset.productId
        );

        const variantId =
          data.variant?.id ||
          data.html
            ?.querySelector('.product-variant-id')
            ?.getAttribute('value');

        if (product) {
          updatePdp(root, product, variantId);
        }
      }
    );
  }

  const observer = new MutationObserver(
    (mutations) => {
      const contentWasAdded = mutations.some(
        (mutation) =>
          [...mutation.addedNodes].some(
            (node) => node.nodeType === 1
          )
      );

      if (contentWasAdded) scheduleLoad();
    }
  );

  const start = () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    scheduleLoad();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();